import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';

@Component({
    selector: 'enlist',
    templateUrl: './enlist.component.html'
})
export class EnlistComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
